import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';

import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  MagicLine,
} from '@uncinc/uncinc-react-kitchen-sink';

const MainMenu = ({ onItemClick }) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));
  const setActiveItemInNavigationRef = useRef(null);
  const hoverMagicLineRef = useRef(null);
  const menuItems = useRef(null);

  // If a page change has been triggered, e.g. from another menu, we want to check if
  // the target page is part of this menu, and if not, hide the magic line.
  useEffect(() => {
    if (setActiveItemInNavigationRef.current && hoverMagicLineRef.current && menuItems.current) {
      let found = false;
      menuItems.current.forEach((item) => {
        const active = item.getIn(['link', 'url']) === currentPage;
        if (active) {
          found = true;

          // If we select a page that is part of this menu, select it.
          const element = document.querySelector(`.Header__menu .menu--main a[href="${currentPage}"]`);
          if (element) {
            hoverMagicLineRef.current({ target: element.closest('.MainMenu__item') });
          }
        }
      });

      if (!found) {
        setActiveItemInNavigationRef.current(false);
      }
    }

  }, [currentPage]);

  return (
    <MagicLine activeClassName="MainMenu__item--active">
      {(setInitialMagicLine, hoverMagicLine, setActiveItemInNavigation) => {
        setActiveItemInNavigationRef.current = setActiveItemInNavigation;
        hoverMagicLineRef.current = hoverMagicLine;
        return (
          <Menu id="main">
            {(items) => {
              menuItems.current = items;
              return (
                <>
                  {items.map((item) => {
                    if (item) {
                      const title = item.getIn(['link', 'title'], 'Untitled');
                      const url = item.getIn(['link', 'url'], '');
                      const active = item.getIn(['link', 'url']) === currentPage;
                      const MainMenuItemClassnames = c('MainMenu__item', {
                        'MainMenu__item--active': active,
                      });

                      if (active) {
                        setActiveItemInNavigation(true);
                      }

                      return (
                        <div
                          key={title}
                          className={MainMenuItemClassnames}
                          onMouseEnter={(e) => { hoverMagicLine(e); }}
                          onMouseLeave={(e) => { setInitialMagicLine(); }}
                        >
                          <CoreLink
                            className="MainMenu__item__link"
                            to={url}
                            onClick={onItemClick}
                          >
                            <span className="MainMenu__item__title">{title}</span>
                          </CoreLink>
                        </div>
                      );
                    }
                  })}
                </>
              );
            }}
          </Menu>
        );
      }}
    </MagicLine>
  );
};

MainMenu.defaultProps = {
  onItemClick: () => {},
};

export default MainMenu;
